/* @ngInject */
function auditBaseService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    deleteAuditComment
  }
  return service

  function deleteAuditComment (commentId, auditId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_AUDITS_ID_COMMENT_ID, [auditId, commentId])
    return ConnectorWebService.fnDelete(url)
  }
}

export { auditBaseService }
